import { useRef, useEffect, forwardRef, useImperativeHandle  }from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography, Stack } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import ReadOnlyTextField from 'src/components/widgets/readonly-textfield';
import QuillEditor from 'src/components/quill-editor';
import SubmitButton, { useCustomFormik } from 'src/components/formik-helper';
import AvatarDisplay from 'src/components/widgets/avatar-display';
import SearchSelectField from 'src/components/widgets/search-select-field';
import DropdownGroups from 'src/components/dropdown/dropdown-groups';
import { mergeNoteFromEditor } from 'src/utils/formatters';

import {
  initialValues,
  validationSchema,
  handleSubmitted,
} from './formik';

export const DetailView = forwardRef(({ item, options, assignCar, assignGroup, blockAccount, apiUpdate, ...other }, ref) => {
  const editorRef = useRef();

  const formik = useCustomFormik({
    validationSchema: validationSchema(item),
    onSubmit: async (values, helpers) => {
      const mergeValues = mergeNoteFromEditor(values, editorRef, item.note);
      await handleSubmitted(mergeValues, assignCar, assignGroup, blockAccount, apiUpdate);
    },
  });

  useEffect(() => {
    initialValues(formik, item);
  }, [item]);

  useImperativeHandle(ref, () => ({
    onCarAssigned: (value) => {
      formik?.setFieldValue('field_cars', null);
    },
    onGroupAssigned: (value) => {
      formik?.setFieldValue('field_groups', null);
    },
  }));

  return (
    <Card>
      <CardContent sx={{ px: 1, py: 2 }}>
        <form onSubmit={formik.handleSubmit} {...other}>
        <Grid container spacing={3}>
          <Grid container spacing={3} xs={12} md={9}>
            <Grid xs={12} md={9}>
              <ReadOnlyTextField label="Họ tên" value={item.name} />
            </Grid>
           
            <Grid xs={6} md={3} sm={6}>
              <ReadOnlyTextField label="Số điện thoại" value={item.phone} enumType='phone' />
            </Grid>

            <Grid xs={6} md={3} sm={6}>
              <ReadOnlyTextField label="Sinh nhật" value={item.birthday} />
            </Grid>

            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Email" value={item.email} />
            </Grid>

            <Grid xs={12} md={12}>
              <ReadOnlyTextField label="Địa chỉ" value={item.address} />
            </Grid>
          </Grid>
          <Grid xs={12} md={3} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <AvatarDisplay avatar={item.avatar} gender={item.gender} />
          </Grid>
        </Grid>
        <Grid xs={12} md={12} sx={{ marginTop: 2 }}>
          <><Grid container spacing={3} sx={{ alignItems: 'center' }}>
              <Grid xs={12}>
                <QuillEditor
                  ref={editorRef}
                  value={item.note}
                  sx={{ height: 130 }}
                />
              </Grid>

              <Grid xs={12} md={3} justifyContent="flex-end">
                <DropdownGroups
                  label="Đơn vị"
                  name="field_groups"
                  type="ns"
                  onSelected={(val) => {
                    formik?.setFieldValue('field_groups', val);
                  }}
                  hintValue={item.groupName || ''}
                />
              </Grid>
              <Grid xs={12} md={3} justifyContent="flex-end">
                <SearchSelectField
                  label="Giao xe"
                  name="field_cars"
                  options={options}
                  onSelected={(val) => {
                    formik?.setFieldValue('field_cars', val);
                  }}
                  hintValue={item.carAssigned || ''}
                />
              </Grid>
              <Grid xs={12} md={5} display="flex"
                sx={{ justifyContent: { xs: 'center', md: 'flex-end' } }}
              >
                <Stack
                  direction={{ xs: 'column', md: 'row' }}
                  spacing={2}
                  alignItems="center"
                  justifyContent="center"
                >
                  {item.status === 0 && (
                    <Typography color="error.main">
                      Tài khoản đã bị khóa
                    </Typography>
                  )}
                  <SubmitButton
                    formik={formik}
                    isRemove={Boolean(item.status)}
                    labelRemove="Khóa tài khoản"
                  />
                </Stack>
              </Grid>
            </Grid>
          </>
        </Grid>
        </form>
      </CardContent>
    </Card>
  );
});

DetailView.propTypes = {
  item: PropTypes.object.isRequired,
  apiUpdate: PropTypes.func,
  apiRemove: PropTypes.func,
};